import React, {FC} from "react";
import {format, isToday, setDate} from "date-fns";
import {Typography} from "@material-ui/core";
import {de} from "date-fns/locale";

interface MonthDaysHeaderProps {
    amountOfDays: number;
    firstOfSelectedMonth: Date;
}

export const MonthDaysHeader: FC<MonthDaysHeaderProps> = ({amountOfDays, firstOfSelectedMonth}) => {
    return (
        <React.Fragment>
            {[...Array(amountOfDays)].map((_o, dayIndex) => {
                const currentDay = setDate(firstOfSelectedMonth, dayIndex + 1);
                const currentDayIsToday = isToday(currentDay);
                return (
                    <div
                        key={"day-" + dayIndex}
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            flex: 1,
                            height: 30
                        }}
                    >
                        <Typography
                            color={currentDayIsToday ? "error" : "textSecondary"}
                            style={{fontSize: 9}}
                        >
                            {format(currentDay, 'EEEEE', {locale: de})}
                        </Typography>
                        <Typography
                            color={currentDayIsToday ? "error" : "textSecondary"}
                        >
                            {dayIndex + 1}
                        </Typography>
                    </div>
                )
            })}
        </React.Fragment>
    )
}